"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorWrapper = exports.Error = exports.Dialog = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
const Dialog = exports.Dialog = (0, _mui.styled)(_components.Dialog)(({
  theme
}) => ({
  margin: 'auto',
  maxWidth: '100%',
  zIndex: theme.zIndex.snackbar,
  [`& .${_components.dialogClasses.content}`]: {
    padding: theme.spacing(6, 3)
  },
  [theme.breakpoints.up('sm')]: {
    maxWidth: '390px',
    [`& .${_components.dialogClasses.content}`]: {
      padding: theme.spacing(6)
    }
  }
}));
const ErrorWrapper = exports.ErrorWrapper = (0, _mui.styled)('div')({
  textAlign: 'center'
});
const Error = exports.Error = (0, _mui.styled)('div')({
  textAlign: 'center'
});
